import { useState } from "react";
import { Box, Chip, TextField, IconButton } from "@mui/material";
import { Send as SendIcon } from "@mui/icons-material";
import { colors, typography, borders } from "../../ui/colors";
import { t as ct } from "../../dashboard/coach/coachTokens";

const GuidedQuestion = ({ question, options = [], onAnswer, disabled }) => {
    const [showOther, setShowOther] = useState(false);
    const [otherText, setOtherText] = useState("");

    const handleChip = (opt) => {
        if (disabled) return;
        onAnswer?.(opt);
    };

    const handleOtherSubmit = () => {
        const text = otherText.trim();
        if (!text || disabled) return;
        onAnswer?.(text);
        setOtherText("");
        setShowOther(false);
    };

    return (
        <Box sx={{ mt: 1 }}>
            {question && (
                <Box sx={{ ...typography.bodySemibold, color: colors.textPrimary, mb: 1 }}>
                    {question}
                </Box>
            )}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                {options.map((opt, i) => (
                    <Chip
                        key={i}
                        label={opt}
                        onClick={() => handleChip(opt)}
                        variant="outlined"
                        size="small"
                        disabled={disabled}
                        sx={{
                            fontFamily: typography.fontFamily,
                            ...typography.small,
                            borderColor: colors.border,
                            color: colors.textSecondary,
                            cursor: "pointer",
                            "&:hover": {
                                borderColor: ct.green,
                                bgcolor: ct.greenLight,
                            },
                        }}
                    />
                ))}
                <Chip
                    label="אחר..."
                    onClick={() => !disabled && setShowOther(s => !s)}
                    variant={showOther ? "filled" : "outlined"}
                    size="small"
                    disabled={disabled}
                    sx={{
                        fontFamily: typography.fontFamily,
                        ...typography.small,
                        borderColor: ct.green,
                        color: showOther ? colors.white : ct.green,
                        bgcolor: showOther ? ct.green : "transparent",
                        cursor: "pointer",
                    }}
                />
            </Box>

            {showOther && (
                <Box sx={{ display: "flex", gap: 1, mt: 1, alignItems: "flex-end" }}>
                    <TextField
                        value={otherText}
                        onChange={(e) => setOtherText(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleOtherSubmit();
                            }
                        }}
                        placeholder="כתוב תשובה..."
                        disabled={disabled}
                        autoFocus
                        fullWidth
                        size="small"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: borders.radius.md,
                                fontFamily: typography.fontFamily,
                                ...typography.small,
                            },
                        }}
                    />
                    <IconButton
                        onClick={handleOtherSubmit}
                        disabled={!otherText.trim() || disabled}
                        sx={{
                            bgcolor: ct.green,
                            color: colors.white,
                            borderRadius: borders.radius.md,
                            width: 34,
                            height: 34,
                            "&:hover": { bgcolor: ct.greenDark },
                            "&.Mui-disabled": { bgcolor: colors.border, color: colors.textMuted },
                        }}
                    >
                        <SendIcon sx={{ fontSize: 16, transform: "rotate(180deg)" }} />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
};

export default GuidedQuestion;
